define('components/type-ahead',[
    'jquery',
    'lib/select2',
    'lib/jquery-ui'
], function($) {

    $.extend(companyInfo.decorators, {

        'type-ahead': function() {
            //overwrite the select2 clearSearch in prototype, to make sure
            //that the searchterm will stay when you remove focus from the box
            window.Select2.class.multi.prototype.clearSearch=function(){
                var placeholder = this.getPlaceholder(),
                    maxWidth = this.getMaxSearchWidth();
               // CurrentThisInput=(this.search); i used this to get the current select2 element and make further action if required.
                if(this.search.val()!==""){}else
                if (placeholder !== undefined  && this.getVal().length === 0 &&  this.search.val()==="") {
                    this.search.val(placeholder).addClass("select2-default");
                    this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
                }
            };

            $(this).select2({
                placeholder: '',
                openOnEnter: false,
                closeOnSelect: true, //CI-7336: this option is by default true
                adaptContainerCssClass: function(str) {
                    return str.replace('input', '');
                },
                maximumSelectionSize: this.getAttribute('data-max') ? this.getAttribute('data-max') : 0
            });
            var values = [];
            $(this).find("[data-selected='true'], [selected='selected']").each(function(index) {
                values.push($(this).val());
            });
            $(this).select2("val", values);
            $("#select2-drop").select2("close");
        },

        'select-keep-open': function() {
            $(this).select2({
              placeholder: '',
              openOnEnter: false,
              closeOnSelect: false,
              adaptContainerCssClass: function(str) {
                return str.replace('input', '');
              },
              maximumSelectionSize: this.getAttribute('data-max') ? this.getAttribute('data-max') : 0,
            });
            var values = [];
            $(this).find("[data-selected='true'], [selected='selected']").each(function(index) {
              values.push($(this).val());
            });
            $(this).select2("val", values);
            $("#select2-drop").select2("close");
        },

        'plain-select': function(){
            var select = $(this);
            var placeholder = select.next("#placeholder.select2-container");
            //check if there is a placeholder for the select2.
            //if so, remove it
            if(placeholder.length){
              placeholder.first().remove();
            }


            select.select2({
                theme: 'plain',
                minimumResultsForSearch: -1,
                containerCssClass: 'select2-single'
            });
        },

        'plain-select-showbox': function(){
            $(this).select2({
                theme: 'plain',
                minimumResultsForSearch: -1,
                allowClear: true,
                containerCssClass: 'select2-showbox'
            });
        },

        'fill-after-select': function() {
            var input = this.getAttribute('data-fill');
            var field = this.getAttribute('data-field');
            $(this).on('autocompleteselect', function(event, ui) {
                if ($(input).val() === '' && ui.item) {
                    $(input).val(ui.item[field]);
                }
            });
        }

    });

});

